import {request} from '@/utils/request';
/**
 * 获取全局数据
 *
 * @returns 返回异步请求得到的远程初始化数据
 */
export async function getUserData() {
    const result = await request.post('/api/perms/user',{},{skipResponseFormat: false});
    if (result.code === 0) {
        return result.data;
    }

    if (location.pathname !== '/login') {
        window.location.href = '/login';
    }

    throw result.msg;
}